'use client';

import { useCallback, useRef } from 'react';

const GAP_PX = 12;

/**
 * Attach to a bar pinned to the bottom of the screen: the chat button moves up
 * so it doesn't cover the bar (`--bottom-cta-offset`, as MobileStickyBar does),
 * and goes back when the bar leaves.
 */
export function useLiftChatAbove<T extends HTMLElement>() {
    const observer = useRef<ResizeObserver | null>(null);

    return useCallback((bar: T | null) => {
        observer.current?.disconnect();
        observer.current = null;
        if (!bar) {
            document.body.style.removeProperty('--bottom-cta-offset');
            return;
        }
        const apply = () =>
            document.body.style.setProperty('--bottom-cta-offset', `${bar.offsetHeight + GAP_PX}px`);
        apply();
        observer.current = new ResizeObserver(apply);
        observer.current.observe(bar);
    }, []);
}

export default useLiftChatAbove;
